import { useMutation } from "@/api/utils/useQuery"
import {
  BackofficeRestMutations,
  RequestRefundPayload,
} from "@/api/backofficeRest/mutations"
import { useCurrentAccountStore } from "@/stores/currentAccount"
import { ICreditRefundForm } from "./CreditRefundMutator.types"

const PENCE_IN_POUND = 100

// Without one the backend labels the Junifer repayment "AWS automated refund".
// It is also appended to the backend's note as "Reference: …", so it must read
// as an explanation rather than a case ID.
const BLANK_REFERENCE_DESCRIPTION =
  "Refund requested by Nova user, without an AWS case ID or other description."

// Round, never truncate: 0.29 * 100 is 28.999999999999996 in floating point.
const poundsToPence = (pounds: string | number): number =>
  Math.round(Number(pounds) * PENCE_IN_POUND)

class CreditRefundMutatorClass {
  creditRefund() {
    return useMutation({
      ...BackofficeRestMutations.account.requestRefund(),
      serializerFn: (data: ICreditRefundForm): RequestRefundPayload => {
        const billingAccountId = useCurrentAccountStore().coreId.data
        if (billingAccountId == null) throw new Error("Missing coreId")

        return {
          billingAccountId,
          body: {
            refundAmountInPence: poundsToPence(data.refundAmount),
            description:
              data.refundReason?.trim() || BLANK_REFERENCE_DESCRIPTION,
          },
        }
      },
    })
  }
}

export const CreditRefundMutator = new CreditRefundMutatorClass()
